<template>
    <div>
        <div class="flex-between">
            <el-button
                class="primary"
                type="primary"
                @click="dialogVisibleNews = true;title = '新建';isfullscreen=true;"
            >新建</el-button>
            <div class="flex-end header-top">
                <el-select
                    v-model="queryData.programaId"
                    clearable
                    @change="listByPageChangeFun"
                    class="input_box"
                    placeholder="请选择栏目"
                >
                    <el-option
                        v-for="item in options"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                    ></el-option>
                </el-select>
                <div class="input_box">
                    <input
                        type="text"
                        v-model="queryData.query"
                        @keyup.enter="listByPageFun()"
                        placeholder="请输入关键字检索"
                    />
                    <span style="cursor: pointer" @click="listByPageFun">
                        <i class="el-icon-search"></i>
                    </span>
                </div>
            </div>
            <!-- el-icon-search -->
        </div>
        <div>
            <el-table
                :header-cell-style="{
                    background: 'rgba(229,244,255,1)',
                    color: '#0077CC',
                    fontWeight: 'bold'
                }"
                align="center"
                header-align="center"
                :data="tableData"
                style="width: 100%">
                <el-table-column
                    type="index"
                    label="序号"
                    header-align="center"
                    align="center"
                    width="80"
                ></el-table-column>
                <el-table-column
                    prop="title"
                    label="新闻名称"
                    header-align="center"
                    width="240"
                    align="center"
                >
                    <template slot-scope="scope">
                        <p class="line-clamp2" :title="scope.row.title">{{scope.row.title}}</p>
                    </template>
                </el-table-column>
                <el-table-column prop="programa" label="所属栏目" header-align="center" align="center"></el-table-column>
                <el-table-column
                    prop="createUserName"
                    label="创建人"
                    header-align="center"
                    align="center"
                ></el-table-column>
                <el-table-column prop="createDt" label="创建时间" header-align="center" align="center">
                    <template slot-scope="scope">{{scope.row.createDt | timestampToTime}}</template>
                </el-table-column>
                <el-table-column
                    prop="publishUserName"
                    label="发布人"
                    header-align="center"
                    align="center"
                ></el-table-column>
                <el-table-column
                    prop="articleTime"
                    label="发生时间"
                    header-align="center"
                    align="center"
                >
                    <template slot-scope="scope">{{scope.row.articleTime | timestampToTime}}</template>
                </el-table-column>

                <el-table-column
                    prop="publishState"
                    label="状态"
                    header-align="center"
                    align="center"
                    width="80"
                >
                    <template slot-scope="scope">{{scope.row.publishState==1 ? '已发布':'未发布'}}</template>
                </el-table-column>
                <!-- 0未发布，1已发布 -->
                <el-table-column label="操作" header-align="center" align="center">
                    <template slot-scope="scope">
                        <el-button
                            v-if="scope.row.publishState==0"
                            @click="deleteArticleFun(scope.row.id)"
                            type="text"
                            size="small"
                        >删除</el-button>
                        <el-button
                            v-if="scope.row.publishState==0"
                            @click="updataFun(scope.row)"
                            type="text"
                            size="small"
                        >修改</el-button>
                        <el-button
                            v-if="scope.row.publishState==0"
                            @click="publishArticleFun(scope.row.id)"
                            type="text"
                            size="small"
                        >发布</el-button>
                        <el-button
                            v-if="scope.row.publishState==1"
                            @click="retractArticleFun(scope.row.id)"
                            type="text"
                            size="small"
                        >撤回</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="flex-end">
                当前 第 {{queryData.currentPage}} 页，共 {{queryData.pages}} 页 {{queryData.total}} 条记录
                <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="queryData.currentPage"
                    :page-size="queryData.pageSize"
                    layout="prev, pager, next, jumper"
                    :total="queryData.total"
                    style="padding: 45px; text-align:right;"
                ></el-pagination>
            </div>
             <!-- <input class="uploadImg" type="file" name="file" multiple id="file">  -->
        </div>
        <el-dialog
            :title="title"
            :visible.sync="dialogVisibleNews"
            :close-on-click-modal="false"
            :fullscreen="isfullscreen"
            :before-close="handleClose"
            append-to-body
        >
            <div>
                <el-form
                    :model="ruleForm"
                    hide-required-asterisk
                    :rules="rules"
                    ref="ruleForm"
                    label-width="85px"
                    label-position="left"
                    class="first-ruleForm flex-between"
                >
                    <div style="margin-right:20px">
                        <el-form-item label="上传封面">
                            <el-upload
                                class="avatar-uploader"
                                :action="action"
                                list-type="picture-card"
                                :show-file-list="false"
                                :on-success="handleAvatarSuccess"
                                :on-error="handleAvatarError"
                            >
                                <img
                                    v-if="ruleForm.articleCover"
                                    :src="httpUrl+'/disk/'+ruleForm.articleCover"
                                    class="avatar"
                                    style="max-width:300px"
                                />
                                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                            </el-upload>
                            <!-- <img
                                    v-if="ruleForm.articleCover"
                                    :src="ruleForm.articleCover"
                                    class="avatar"
                                /> -->
                            <!-- <input id="fileUpload" @change="fileUpload" type="file" /> -->
                        </el-form-item>
                    </div>
                    <div style="width:calc(100% - 315px)">
                        <el-form-item label="文章名称" prop="title">
                            <el-input v-model="ruleForm.title"></el-input>
                        </el-form-item>
                        <el-form-item label="发生时间" prop="articleTime">
                            <el-date-picker
                                v-model="ruleForm.articleTime"
                                format="yyyy-MM-dd HH:mm:ss "
                                value-format="yyyy-MM-dd HH:mm:ss"
                                type="datetime"
                                placeholder="选择日期"
                            ></el-date-picker>
                        </el-form-item>
                        <el-form-item label="选择栏目" prop="programaId">
                            <el-select v-model="ruleForm.programaId" placeholder="请选择">
                                <el-option
                                    v-for="item in options"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id"
                                ></el-option>
                            </el-select>
                        </el-form-item>

                        <el-form-item label="来源">
                            <el-input v-model="ruleForm.source"></el-input>
                        </el-form-item>
                    </div>
                </el-form>
                <div class="edit_container">
                    <vue-ueditor-wrap
                        :destroy="true"
                        @ready="ready"
                        v-model="ruleForm.content"
                        :config="myConfig"
                    ></vue-ueditor-wrap>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <!-- <el-button @click="dialogVisibleNews = false" >返 回</el-button>
        <el-button type="primary" @click="dialogVisibleNews = false"
          >确 定</el-button
          http://192.168.0.118:9998/disk/2020\04\24\thumbnail1587722860108示例图片_01.jpg
                >-->
                <button class="el-button" @click="handleClose">返 回</button>
                <button class="el-button1" @click="submitForm">确 定</button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import VueUeditorWrap from "vue-ueditor-wrap";

// const UE = require('vue-ueditor-wrap')

import {
    listByPageArticle,
    deleteArticle, //删除
    retractArticle, //撤回
    publishArticle, //发布
    listPrograma, //栏目
    insertArticle, //新增
    updateArticle, //修改
    pictureUpload //上传图片
    // editPassword
} from "../../../api/news.js";
import axios from "axios";
export default {
    props:{
        isPublish:{
            type:Number,
            default(){
　　　　　　　　return 
            }
        }
    },
    name: "breadcrumbList",
    filters: {
        timestampToTime(timestamp) {
            let date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
            if (!timestamp) {
                return "";
            }
            let Y = date.getFullYear() + "-";
            let M =
                (date.getMonth() + 1 < 10
                    ? "0" + (date.getMonth() + 1)
                    : date.getMonth() + 1) + "-";
            let D = date.getDate() + " ";
            let h = date.getHours() + ":";
            let m = date.getMinutes() + ":";
            let s = date.getSeconds();
            return Y + M + D + h + m + s;
        }
    },
    components: {
        VueUeditorWrap
    },
    data() {
        return {
            httpUrl:process.env.VUE_APP_URL,
            isfullscreen: false,
            msg: "",
            sign: "",
            title: "",
            myConfig: {
                // 编辑器不自动被内容撑高
                autoHeightEnabled: false,
                // 初始容器高度
                initialFrameHeight: 400,
                // 初始容器宽度
                initialFrameWidth: "100%",
                // 上传文件接口（这个地址是我为了方便各位体验文件上传功能搭建的临时接口，请勿在生产环境使用！！！）
                serverUrl: "",
                zIndex:9999,
                // UEditor 资源文件的存放路径，如果你使用的是 vue-cli 生成的项目，通常不需要设置该选项，vue-ueditor-wrap 会自动处理常见的情况，如果需要特殊配置，参考下方的常见问题2
                // UEDITOR_HOME_URL: "/static/ueditor/"
                UEDITOR_HOME_URL: "/ueditor/"
            },
            tableData: [],
            dialogVisibleNews: false,
            content: "",
            editorOption: {},
            // 表单参数
            ruleForm: {
                title: "",
                content: "",
                articleTime: "",
                programaId: "",
                source: "", //来源
                articleCover: "" //封面
            },
            //验证规则
            rules: {
                title: [
                    {
                        required: true,
                        message: "请输入文章标题",
                        trigger: "blur"
                    },
                    {
                        min: 1,
                        max: 127,
                        message: "文章标题长度在 1 到 127 个字符",
                        trigger: "blur"
                    }
                ],
                content: [
                    {
                        required: true,
                        message: "请输入文章内容",
                        trigger: "blur"
                    }
                ],
                articleTime: [
                    {
                        required: true,
                        message: "请选择发布时间",
                        trigger: "blur"
                    }
                ],
                programaId: [
                    {
                        required: true,
                        message: "请选择栏目名称",
                        trigger: "blur"
                    }
                ]
            },
            //下拉框
            options: [],
            //查询条件
            queryData: {
                currentPage: 1, //当前页
                pageSize: 10,
                pages: "", //总页数
                total: 0,
                query: "", //模糊搜索
                state: -1,
                programaId: ""
            },
            //查询条件
            queryData2: {
                currentPage: 1, //当前页
                pageSize: 10,
                query: "", //模糊搜索
            },
            // 未发布--发布--全部
            status: "",
            //上传图片接口地址
            action: ""
        };
    },
    methods: {
        
        ready(editorInstance) {
            // //console.log(`编辑器实例${editorInstance.key}: `, editorInstance)
        },
        // 分页
        handleSizeChange(val) {
            this.queryData.pageSize = val;
            this.listByPageFun();
            //console.log(`每页 ${val} 条`);
        },
        handleCurrentChange(val) {
            //console.log(val);
            this.queryData.currentPage = val;
            //console.log(this.queryData);
            // this.getuserlist(this.queryData.currentPage,this.queryData.pageSize);
            this.listByPageFun();
            //console.log(`当前页: ${val}`);
        },
        // 下拉框查询事件
        listByPageChangeFun(event) {
            //console.log(event);
            this.queryData.programaId = event;
            this.listByPageFun();
        },
        //列表
        listByPageFun( serch = 1) {
            if (serch == -1) {
                this.queryData = {
                    currentPage: 1, //当前页
                    pageSize: 10,
                    pages: "", //总页数
                    total: 0,
                    query: "", //模糊搜索
                    programaId: ""
                };
                
            }
            listByPageArticle({
                currentPage: this.queryData.currentPage,
                pageSize: this.queryData.pageSize,
                query: this.queryData.query,
                programaId: this.queryData.programaId,
                isPublish: this.isPublish
            })
                .then(res => {
                    //console.log(res, "新闻列表==成功");
                    if (res.code == 200) {
                        this.tableData = res.data.list || [];
                        this.queryData.total = res.data.total || 0;
                        this.queryData.pages = res.data.pages || 0;
                        //console.log(this.queryData, "this.queryData");
                        // this.$emit("listByPageFather");
                    } else {
                        this.$message.error(res.message);
                    }
                })
                .catch(err => {
                    this.$message.error(err.message);
                });
        },
        //删除文章
        deleteArticleFun(id) {
            let that = this;
            this.$confirm("确定删除该信息么？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            })
                .then(() => {
                    deleteArticle({
                        id: Number(id)
                    })
                        .then(res => {
                            if (res.code == 200) {
                                that.$message({
                                    message: "删除成功",
                                    type: "success"
                                });
                                this.listByPageFun();
                            } else {
                                this.$message.error(res.message);
                            }
                        })
                        .catch(err => {
                            this.$message.error(err.message);
                        });
                })
                .catch(err => {
                    //console.log(err, "错误");
                    this.$message({
                        type: "info",
                        message: "已取消删除"
                    });
                });
        },

        //撤回文章
        retractArticleFun(id) {
            let that = this;
            this.$confirm("确定撤回该信息么？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            })
                .then(() => {
                    retractArticle({
                        id: Number(id)
                    })
                        .then(res => {
                            if (res.code == 200) {
                                that.$message({
                                    message: "撤回成功",
                                    type: "success"
                                });
                                this.listByPageFun();
                            } else {
                                this.$message.error(res.message);
                            }
                        })
                        .catch(err => {
                            this.$message.error(err.message);
                        });
                })
                .catch(err => {
                    //console.log(err, "错误");
                    this.$message({
                        type: "info",
                        message: "已取消撤回"
                    });
                });
        },

        //发布文章
        publishArticleFun(id) {
            let that = this;
            this.$confirm("确定发布该信息么？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            })
                .then(() => {
                    publishArticle({
                        id: Number(id)
                    })
                        .then(res => {
                            if (res.code == 200) {
                                that.$message({
                                    message: "发布成功",
                                    type: "success"
                                });
                                this.listByPageFun();
                            } else {
                                this.$message.error(res.message);
                            }
                        })
                        .catch(err => {
                            this.$message.error(err.message);
                        });
                })
                .catch(err => {
                    //console.log(err, "错误");
                    this.$message({
                        type: "info",
                        message: "已取消发布"
                    });
                });
        },

        //栏目
        listProgramaFun() {
            listPrograma(this.queryData2)
                .then(res => {
                    //console.log(res, "栏目查询成功");
                    if (res.code == 200) {
                        this.options = res.data.list || [];
                    } else {
                        this.$message.error(res.message);
                    }
                })
                .catch(err => {
                    this.$message.error(err.message);
                });
        },
        //新增文章
        submitForm(formName = "ruleForm") {
             let info = {...this.ruleForm}
            this.$refs["ruleForm"].validate(valid => {
                if (valid) {
                    if (info.id) {
                        updateArticle(info)
                            .then(res => {
                                if (res.code == 200) {
                                    this.$message({
                                        message: "修改成功",
                                        type: "success"
                                    });

                                    this.listByPageFun();
                                } else {
                                    this.$message.error(res.message);
                                }
                            })
                            .catch(err => {
                                this.$message.error(err.message);
                            });
                    } else {
                        // this.ruleForm.articleSign = this.sign;
                        console.log(info);
                        insertArticle(info)
                            .then(res => {
                                if (res.code == 200) {
                                    this.$message({
                                        message: "新增成功",
                                        type: "success"
                                    });
                                    this.listByPageFun();
                                } else {
                                    this.$message.error(res.message);
                                }
                            })
                            .catch(err => {
                                this.$message.error(err.message);
                            });
                    }
                    this.handleClose();
                } else {
                    //console.log("error submit!!");
                    return false;
                }
            });
        },

        //修改
        updataFun(row) {
            //console.log({...row});
            this.ruleForm = {
                title: row.title,
                content: row.content,
                id: row.id,
                articleSign: row.articleSign,
                // articleTime:'2018-09-09',
                articleTime: this.$options.filters["timestampToTime"](
                    row.articleTime
                ),
                programaId: row.programaId,
                source: row.source, //来源
                articleCover: row.articleCover || "" //封面
            };
            this.title = "修改信息";
            this.isfullscreen = true;
            this.dialogVisibleNews = true;
        },
        // 弹框关闭
        handleClose() {
            this.$refs["ruleForm"].resetFields();
            this.ruleForm = {
                content: "",
                programaId: "",
                articleTime: "",
                title: "",
                source: "", //来源
                articleCover: "" //封面
            };
            //console.log(this.ruleForm,'this.ruleForm--关闭');
            this.dialogVisibleNews = false;
        },
        // 图片上传事件
        handleAvatarSuccess(res, file) {
            //console.log(res, file,'图片上传成功==');
            // this.imageUrl = URL.createObjectURL(file.raw);
            this.ruleForm.articleCover = res.data.filePath;
        },
        beforeAvatarUpload(file) {
            console.log(file);
            pictureUpload(file).then(res=>{
                if(res.code==200){
                    // this.$message.error(err.data.message);
                }else{
                    this.$message.error(res.message);
                }
            }).catch(err=>{
                this.$message.error(err.message);
            })
        },
        handleAvatarError(err, file) {
            //console.log(err, file,'图片上传失败==');
            this.$message.error(err.data.message);
        },
        fileUpload(){
            let fileObj = document.getElementById('fileUpload').files[0]
            if (fileObj) {
                let url = `${process.env.VUE_APP_URL}/file/fileupload`;
                let formData = new FormData();
                formData.append('file', fileObj);
                let xhr = new XMLHttpRequest();
                xhr.onload = function () {
                    console.log('ok')
                    var res = JSON.parse(xhr.responseText)
                    console.log(JSON.parse(xhr.responseText))
                    if(res.code==200){
                        localStorage.setItem("flieImg",res.data.fileCompressionPath);
                        alert(res.data.fileCompressionPath)
                        // document.getElementById('file')
                    }else{
                        alert(res.message)
                    }
                }
                xhr.onerror = function () {
                    console.log('fail')
                    alert(fail.message)
                }
                xhr.open('post', url, true)
                xhr.send(formData)

            } else {
                console.log('请选择文件')
            }
        
    }
    },
    mounted() {},
    created() {
        this.listByPageFun();
        this.listProgramaFun();
        let href = window.location.href;
        this.myConfig.serverUrl = `${process.env.VUE_APP_URL}/ueditor/config`;
        this.action = `${process.env.VUE_APP_URL}/file/fileupload`;
        // if (href.indexOf("localhost") == -1) {
        //     this.myConfig.serverUrl = `${process.env.VUE_APP_URL}/ueditor/config`;
        //     this.action = `${process.env.VUE_APP_URL}/file/fileupload`;
        // } else {
        //     this.myConfig.serverUrl =
        //         href.split("/#/")[0] + "/test/ueditor/config";
        //     this.action = `${href.split("/#/")[0]}/test/file/fileupload`;
        // }
    },
    watch:{
        isPublish: {
            handler(newVal) {
                console.log(newVal)
            },
            deep: true
        }
    }
};
        
    </script>
<style lang="less" scoped>
// /deep/ .el-dialog{
//     margin-top: 0 !important;
//     height: 100% !important;
// }
// .edui-editor-iframeholder{
//     height: calc(100vh - 410px) !important;
// }
.el-table {
    margin-top: 20px;
    /deep/ th .cell {
        font-weight: bold;
    }
    .el-button--text {
        color: #197cda;
    }
    .ql-editor {
        min-height: 150px;
    }
}
/deep/ .dialog-footer {
        .el-button {
            width: 80px;
            height: 30px;
            background: rgba(255, 255, 255, 1);
            border: 1px solid rgba(0, 145, 255, 1);
            box-shadow: 0px 1px 3px 0px rgba(0, 72, 128, 0.3);
            border-radius: 4px;
            padding: 0;
            color:#0091FF;

        }
        .el-button1{
            width:80px;
            height:30px;
            background:rgba(0,126,255,1);
            border:1px solid rgba(0,145,255,1);
            box-shadow:0px 1px 3px 0px rgba(0,72,128,0.3);
            border-radius:4px;
            color: #fff;
            margin-left: 10px;
        }
    }
.flex-end {
    display: flex;
    justify-content: flex-end;
    color: #999999;
    font-size: 14px;
    align-items: center;
    margin-top: 30px;
}
.flex-between {
    display: flex;
    justify-content: space-between;
    .header-top {
        margin-top: 0;
    }
}
.primary {
    width: 80px;
    height: 30px;
    background: rgba(0, 145, 255, 1);
    box-shadow: 0px 1px 3px 0px rgba(0, 72, 128, 0.3);
    border-radius: 4px;
    padding: 0;
}
.input_box {
    width: 300px;
    height: 36px;
    border: 1px solid rgba(153, 194, 255, 1);
    border-radius: 4px;
    margin-left: 20px;
    input {
        width: 270px;
        height: 36px;
        line-height: 36px;

        color: #666;
        font-size: 14px;
        box-sizing: border-box;
        padding-left: 10px;
        border: none;
        outline: none;
    }
    /deep/ .el-input__inner {
        border: none;
        outline: none;
        height: 36px;
        line-height: 36px;
        color: #666;
    }
    /deep/ .el-input__icon {
        line-height: 100%;
    }
    /deep/ input::-webkit-input-placeholder {
        color: rgba(153, 153, 153, 1);
        font-style: italic;
    }
    /deep/ input::-moz-input-placeholder {
        color: rgba(153, 153, 153, 1);
        font-style: italic;
    }
    /deep/ input::-ms-input-placeholder {
        color: rgba(153, 153, 153, 1);
        font-style: italic;
    }
}
.avatar-uploader{
    .el-icon-plus{
        border:1px #ccc solid;
        padding:5px 10px;

    }
}
.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}
.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}
.news .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 180px;
    height: 180px;
    line-height: 180px;
    object-fit: cover;
    text-align: center;
}
.news .avatar {
    width: 180px;
    height: auto;
    display: block;
    max-height: 1000px;
}
</style>
